// extracted by mini-css-extract-plugin
module.exports = {"create_new_tag":"tags_create_new_tag__18lim"};